import screenfull from 'screenfull';

window.skinUtils = {
  cancelFullScreen: () => screenfull.isFullscreen && screenfull.exit(),
};
